export default __webpack_public_path__ + "static/media/blogTest.a7d7d1c0.png";